export default __webpack_public_path__ + "static/media/1.c9efd2fd.png";